import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Becoming", id: "becoming" },
  { label: "Flow", id: "flow" },
  { label: "Frameworks", id: "frameworks" },
  { label: "Offerings", id: "offerings" },
  { label: "Harmonia", id: "harmonia" },
  { label: "Words", id: "testimonials" },
  { label: "Reflections", id: "reflections" },
  { label: "Connect", id: "connect" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => (e) => {
    if (!isHome) return; // let router handle
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled ? "bg-bone/85 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-serif text-2xl tracking-tight text-charcoal hover:text-bronze transition-colors duration-500"
        >
          <span className="italic">h</span>
          <span className="mx-[1px]">·</span>
          <span>el-baba</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={isHome ? `#${l.id}` : `/#${l.id}`}
              onClick={handleClick(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-[11px] uppercase tracking-[0.22em] text-ink hover:text-bronze transition-colors duration-500 link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-charcoal"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden bg-bone border-t border-stone/30">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                href={isHome ? `#${l.id}` : `/#${l.id}`}
                onClick={handleClick(l.id)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="text-sm uppercase tracking-[0.22em] text-charcoal"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Nav;
